import { Box, IconButton, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { useState } from "react";
import { sendMessage } from "../utility/sendMessage";
import { baseWhite } from "../utility/colorPalette";

interface MessageInputContainerProps {
  sendAndReceiveMessage: (input: string) => void;
}

export const MessageInputContainer: React.FC<MessageInputContainerProps> = ({
  sendAndReceiveMessage,
}) => {
  const [input, setInput] = useState("");

  const sendButtonClicked = () => {
    setInput("");
    sendAndReceiveMessage(input);
  };

  return (
    <Box
      sx={{
        p: 1,
        borderTop: "1px solid #ccc",
        width: "100%",
        margin: 0,
      }}
    >
      <TextField
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "16px", // ← 丸み
            backgroundColor: "white", // ← 入力部の背景を白に
          },
        }}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        // onKeyDown={(e) => {
        //   if (e.key === "Enter") sendButtonClicked();
        // }}
        fullWidth
        multiline
        minRows={1}
        maxRows={3}
        placeholder="メッセージを入力"
        size="small"
        // autoFocus
        InputProps={{
          endAdornment: (
            <IconButton
              onClick={sendButtonClicked}
              disabled={input.trim() === ""}
            >
              <SendIcon
                sx={{
                  color: input.trim() === "" ? "gray" : "primary.main", // ← ここで切り替え
                }}
              />
            </IconButton>
          ),
        }}
      />
    </Box>
  );
};
